import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/partners')({
  component: PartnersPage,
});

function PartnersPage() {
  return <div className="placeholder">Partner Program — Coming Soon</div>;
}
